import { useEffect, useState } from 'react'
import agentService from '../../services/agentService'
import toastService from '../../services/toastService'
import styles from './AgentReferral.module.scss'

// Agent's referral code and link: customers who register with it are linked to the agent
const AgentReferral = () => {
  const [referral, setReferral] = useState(null)

  useEffect(() => {
    agentService
      .getAgentCode()
      .then((response) => setReferral(response))
      .catch(() => {})
  }, [])

  const copyLink = () => {
    navigator.clipboard
      .writeText(referral.link)
      .then(() => toastService.show('success', 'Referral link copied'))
      .catch(() => toastService.show('error', 'Could not copy the link'))
  }

  if (!referral?.agentCode) return null

  return (
    <div className={styles.wrapper}>
      <p className='mb-1'>
        Your agent code: <strong className={styles.code}>{referral.agentCode}</strong>
      </p>
      <p className='small mb-2'>
        Customers who register with your link or enter your code are linked to you for commission.
      </p>
      <div className={styles.linkRow}>
        <input className='form-control bordered' type='text' value={referral.link} readOnly />
        <button className='btn btn-lightblue' onClick={copyLink}>
          Copy link
        </button>
      </div>
    </div>
  )
}

export default AgentReferral
